import { Flex } from "antd";
import { CSSProperties, ReactNode } from "react";

const Container = ({
  children,
  vertical = true,
  centered = false,
  style,
  className = ""
}: {
  children: ReactNode,
  vertical?: boolean,
  centered?: boolean,
  style?: CSSProperties,
  className?: string
}) => {
  return (
    <Flex
      vertical={vertical}
      align={centered ? "center" : undefined}
      className={`overflow-hidden max-w-[1320px] w-full mx-auto px-[12px] ${className}`}
      style={{
        ...style,
      }}
    >
      {children}
    </Flex>
  );
};

export default Container;
